import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../LoadingSpinner";
import dayjs from "dayjs";
import {
  addRequestInitiation,
  fetchDataById,
} from "../../../api/requestCreation";
import DateTimePickerInput from "../../input/DateTimePickerInput";
import Button from "../../input/Button";
import { Card, CardContent } from "semantic-ui-react";
import { useSelector } from "react-redux";
import Input from "../../input/Input";
import { isAfter, isBefore } from "../../../dateConfig";
import { toast } from "react-toastify";
import {
  addAndUpload,
  getDocumentByOpeAndRef,
} from "../../../api/documentUpload";
import { FORMS, MODULES } from "../../../const";
import Dropdown from "../../input/Dropdown";
import CheckboxSlider from "../../CheckboxSlider";
import { processRequest } from "../../../api/requestApprovalApi";

const FORM = FORMS.REQUEST.CREATION_INFO.form;
const MAIN_FORM = FORMS.REQUEST.CREATION.form;
const REQUEST_COPY_FORM = FORMS.REQUEST.COPY.form;

function RequestCopyModal({ jobId, reqId, close }) {
  const user = useSelector((state) => state.user);
  const auth = useSelector(
    (state) => state.user.permissions[MODULES.Transaction],
  );
  const mainFormPermissions = auth?.[MAIN_FORM];
  const requestFormPermissions = auth?.[REQUEST_COPY_FORM];
  const allowBackDates = mainFormPermissions?.FORM?.REQUEST_BACK_DATE;
  const allowJobCreate = requestFormPermissions?.FORM?.CREATE_JOB;
  const now = new Date();
  const [isLoading, setIsLoading] = useState(false);
  const [resetFields, setResetFields] = useState(false);
  const [resetLocationFields, setResetLocationFields] = useState(false);
  const [requestData, setRequestData] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [creatorRemark, setCreatorRemark] = useState("");
  const [createJob, setCreateJob] = useState(true); // default checked
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [currentErrors, setCurrentErrors] = useState({});
  const [newDates, setNewDates] = useState({
    reqBookingRequiredDate: "",
    locations: [], // [{ rlkId, rlkLocationTypeValue, rlkArrivalEta, rlkDepartureEta }]
  });

  useEffect(() => {
    console.log(
      "[DEBUG_REQUEST_COPY] this is the request id: ",
      reqId ? reqId : 0,
    );
    if (reqId) {
      resetLocationETAs();
      const fetchRequestData = async () => {
        setIsLoading(true);
        try {
          const response = await fetchDataById(reqId);
          console.log(
            "[DEBUG_REQUEST_COPY] the fetched request data: ",
            response,
          );
          setRequestData(response);
          setIsLoading(false);
        } catch (error) {
          console.error(error);
          setIsLoading(false);
        }
      };
      fetchRequestData();
    }
  }, [reqId]);

  useEffect(() => {
    console.log("[DEBUG_LOCATION_ETA] requestData:", requestData);
    if (requestData?.reqId) {
      console.log("[DEBUG_LOCATION_ETA] requestData.reqId:", requestData.reqId);
      console.log(
        "[DEBUG_LOCATION_ETA] requestData.requestLocationsResponses:",
        requestData.requestLocationsResponses,
      );

      const mappedLocations = requestData.requestLocationsResponses.map(
        (loc) => {
          console.log("[DEBUG_LOCATION_ETA] Mapping location:", {
            rlkId: loc.rlkId,
            rlkLocationType: loc.rlkLocationType,
            rlkLocationTypeValue: loc.rlkLocationTypeValue,
            rlkArrivalEta: loc.rlkArrivalEta,
            rlkDepartureEta: loc.rlkDepartureEta,
          });

          return {
            rlkId: loc.rlkId,
            rlkLocationType: loc.rlkLocationType,
            rlkLocationTypeValue: loc.rlkLocationTypeValue,
            rlkArrivalEta: loc.rlkArrivalEta ? new Date(loc.rlkArrivalEta) : "",
            rlkDepartureEta: loc.rlkDepartureEta
              ? new Date(loc.rlkDepartureEta)
              : "",
          };
        },
      );

      console.log(
        "[DEBUG_LOCATION_ETA] Final mappedLocations:",
        mappedLocations,
      );

      setNewDates({
        reqBookingRequiredDate: shiftFromNow(
          requestData.reqCreatedDate,
          requestData.reqBookingRequiredDate,
        ),
        locations: requestData.requestLocationsResponses
          .sort((a, b) => a.rlkLocationType - b.rlkLocationType) // Start = 1, Via = 3, End = 2
          .map((loc) => {
            const base =
              loc.rlkArrivalEta ||
              loc.rlkDepartureEta ||
              requestData.reqCreatedDate;

            return {
              rlkId: loc.rlkId,
              rlkLocationType: loc.rlkLocationType,
              rlkLocationTypeValue: loc.rlkLocationTypeValue,
              locationName: loc.locationName,
              // rlkArrivalEta: shiftFromNow(base, loc.rlkArrivalEta),
              // rlkDepartureEta: shiftFromNow(base, loc.rlkDepartureEta),
            };
          }),
      });
    }
  }, [requestData]);

  const validateFormFields = () => {
    const errors = {};

    if (!newDates.reqBookingRequiredDate) {
      errors.reqBookingRequiredDate = "Booking Required Date is required";
    }

    const startLoc = newDates.locations.find(
      (loc) => loc.rlkLocationType === 1,
    );
    const endLoc = newDates.locations.find((loc) => loc.rlkLocationType === 2);
    const viaLocs = newDates.locations.filter(
      (loc) => loc.rlkLocationType === 3,
    );

    newDates.locations.forEach((loc) => {
      const arrival = loc.rlkArrivalEta;
      const departure = loc.rlkDepartureEta;

      if (!arrival) {
        errors[`arrival_${loc.rlkId}`] = "Arrival ETA is required";
      }
      if (!departure) {
        errors[`departure_${loc.rlkId}`] = "Departure ETA is required";
      }

      // Rule 1: Arrival must be before Departure
      if (arrival && departure && isAfter(dayjs(arrival), departure)) {
        errors[`arrival_${loc.rlkId}`] = "Arrival must be before Departure";
        errors[`departure_${loc.rlkId}`] = "Departure must be after Arrival";
      }
    });

    // Rule 2: Start vs End
    if (startLoc && endLoc) {
      if (
        startLoc.rlkArrivalEta &&
        endLoc.rlkArrivalEta &&
        isAfter(dayjs(startLoc.rlkArrivalEta), endLoc.rlkArrivalEta)
      ) {
        errors[`arrival_${startLoc.rlkId}`] =
          "Start arrival must be before End arrival";
      }
      if (
        startLoc.rlkDepartureEta &&
        endLoc.rlkDepartureEta &&
        isAfter(dayjs(startLoc.rlkDepartureEta), endLoc.rlkDepartureEta)
      ) {
        errors[`departure_${startLoc.rlkId}`] =
          "Start departure must be before End departure";
      }
    }

    // Rule 3: Via locations in between
    viaLocs.forEach((loc) => {
      if (
        startLoc?.rlkDepartureEta &&
        loc.rlkArrivalEta &&
        isBefore(dayjs(loc.rlkArrivalEta), startLoc.rlkDepartureEta)
      ) {
        errors[`arrival_${loc.rlkId}`] =
          "Via Arrival must be after Start Departure";
      }
      if (
        endLoc?.rlkArrivalEta &&
        loc.rlkDepartureEta &&
        isAfter(dayjs(loc.rlkDepartureEta), endLoc.rlkArrivalEta)
      ) {
        errors[`departure_${loc.rlkId}`] =
          "Via Departure must be before End Arrival";
      }
    });

    if (Object.keys(errors).length > 0) {
      setCurrentErrors(errors);
      toast.error("Please fix the errors in location ETAs.");
      return false;
    }

    return true;
  };

  const uploadCopiedDocuments = async (newReqId, documentResponses) => {
    if (!documentResponses || documentResponses.length === 0) return;

    for (let doc of documentResponses) {
      try {
        const response = await fetch(`/api/file/download/${doc.docUrl}`); // Adjust base path if needed
        if (!response.ok) throw new Error("File fetch failed");
        const fileBlob = await response.blob();

        const formData = new FormData();
        formData.append("multipartFile", fileBlob, doc.docName || "file");
        formData.append(
          "documentRequest",
          JSON.stringify({
            ...doc,
            docId: null, // remove original ID
            docReference: newReqId, // attach to new request
          }),
        );
        formData.append("isImage", doc.docCategory === 1);
        await addAndUpload(formData);
      } catch (err) {
        console.error("[DOCUMENT_UPLOAD_ERROR]", err);
        toast.error("One or more documents failed to copy");
      }
    }
  };

  const handleCreateCopy = async () => {
    if (!validateFormFields()) return;
    setIsButtonLoading(true);
    const now = new Date();

    const mappedLocations = requestData.requestLocationsResponses.map((loc) => {
      const updated = newDates.locations.find((l) => l.rlkId === loc.rlkId);
      return {
        ...loc,
        rlkId: null,
        rlkRequest: null,
        rlkArrivalEta: updated?.rlkArrivalEta,
        rlkDepartureEta: updated?.rlkDepartureEta,
        createdDate: now.toISOString(),
        lastModifiedDate: now.toISOString(),
        requestConsigneesRequests: (loc.requestConsigneesResponses || []).map(
          (con) => ({
            rcoLocation: loc.rlkLocation,
            rcoConsignee: con.rcoConsignee,
            rcoConsignmentType: con.rcoConsignmentType,
            rcoCbm: con.rcoCbm,
            rcoQty: con.rcoQty,
            rcoActive: con.rcoActive,
            requestItemsRequests: [],
          }),
        ),
        requestConsigneesResponses: undefined,
      };
    });

    const startLocation = mappedLocations.find((l) => l.rlkLocationType === 1);
    const endLocation = mappedLocations.find((l) => l.rlkLocationType === 2);

    // Convert documentResponses into documentRequests
    const documentRequests = (requestData.documentResponses || []).map(
      (doc) => ({
        docId: null,
        docReference: null, // updated after insert
        docOtherReference: doc.docOtherReference,
        docOperation: doc.docOperation,
        docCategory: doc.docCategory,
        fileType: doc.fileType,
        fileName: doc.fileName,
        docName: doc.docName,
        docDescription: doc.docDescription,
        docStatus: doc.docStatus,
        docUploadStatus: doc.docUploadStatus,
        docActive: doc.docActive,
        createdBy: user.username,
        createdDate: now.toISOString(),
        lastModifiedBy: user.username,
        lastModifiedDate: now.toISOString(),
      }),
    );

    const payload = {
      ...requestData,
      reqId: null,
      reqCode: null,
      reqCreatedDate: now.toISOString(),
      reqStatus: 1,
      reqActive: 1,
      reqApprovedDate: null,
      reqRemarks: creatorRemark,
      reqBookingRequiredDate: newDates.reqBookingRequiredDate,
      reqStarkRlkId: startLocation?.rlkLocation,
      reqEndRlkId: endLocation?.rlkLocation,
      requestLocationsRequests: mappedLocations,
      reqDuplicateFrom: reqId,
      requestOtherRequests: (requestData.requestOtherResponses || []).map(
        (other) => ({
          ...other,
          rotId: null,
          rotReference: null,
          createdDate: now.toISOString(),
          lastModifiedDate: now.toISOString(),
        }),
      ),
      documentRequests, // ✅ include documentRequests for backend DTO
      requestLocationsResponses: undefined,
      documentResponses: undefined,
      requestOtherResponses: undefined,
      requestSchedulerResponse: undefined,
      author: user.username,
    };

    try {
      const returnedResponse = await addRequestInitiation(payload);

      const response = returnedResponse.response;
      if (response) {
        await uploadCopiedDocuments(
          response.reqId,
          requestData.documentResponses,
        );

        const documentResponses = await getDocumentByOpeAndRef(
          7,
          response.reqId,
        );
        response.documentResponses = documentResponses;
      }
      setIsButtonLoading(false);

      if (createJob) {
        try {
          let data = {
            requestId: response.reqId,
            status: 2,
            remark: 6,
            remarkDesc: "",
            chargeType: 5,
            route: 1,
            jobType: 1,
            numOfJobs: 1,
            createdBy: user.username,
          };
          const jobResponse = await processRequest(data);
        } catch (error) {
          console.error(error);
        }
      }
      close(response);
    } catch (error) {
      console.error("[REQUEST_COPY_ERROR]", error);
      toast.error("Failed to create request copy");
      setIsButtonLoading(false);
    }
  };

  const shiftFromNow = (originalBase, originalTarget) => {
    if (!originalBase || !originalTarget) return null;
    const base = new Date(originalBase);
    const target = new Date(originalTarget);
    const diff = target - base; // milliseconds
    return new Date(Date.now() + diff);
  };

  const resetLocationETAs = () => {
    const resetLocations = newDates.locations.map((loc) => ({
      ...loc,
      rlkArrivalEta: "",
      rlkDepartureEta: "",
    }));

    setNewDates((prev) => ({
      ...prev,
      locations: resetLocations,
    }));

    setCurrentErrors((prev) => {
      const cleared = { ...prev };
      newDates.locations.forEach((loc) => {
        delete cleared[`arrival_${loc.rlkId}`];
        delete cleared[`departure_${loc.rlkId}`];
      });
      return cleared;
    });
  };

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Card style={{ width: "100%", height: "100%", margin: 0, padding: 0 }}>
          <CardContent>
            <form
              className="ui form"
              style={{ overflowY: "auto", height: "75vh" }}
            >
              <div className="ui segment">
                <h4 className="ui dividing header">Request Initiation</h4>
                {/*<div className="two fields">*/}
                {/*    <Dropdown*/}
                {/*        label="Select Customer"*/}
                {/*        //options={customerOptions} // fetch and store in state*/}
                {/*        //value={selectedCustomer}*/}
                {/*        //onChange={(e, { value }) => setSelectedCustomer(value)}*/}
                {/*    />*/}
                {/*</div>*/}
                <div
                  className="three fields"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <DateTimePickerInput
                    value={newDates.reqBookingRequiredDate}
                    label="Booking Required Date"
                    required={true}
                    reset={resetFields}
                    validators={
                      !allowBackDates
                        ? [
                            {
                              func: (date) => isAfter(date, new Date()),
                              message:
                                "Date and Time should be after current date and time",
                            },
                          ]
                        : []
                    }
                    error={currentErrors.reqBookingRequiredDate}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { reqBookingRequiredDate: _, ...rest } =
                          prevState;
                        return rest;
                      })
                    }
                    setReset={setResetFields}
                    onAccept={(value) =>
                      setNewDates((prev) => ({
                        ...prev,
                        reqBookingRequiredDate: value,
                      }))
                    }
                  />
                  <Input
                    value={creatorRemark}
                    onChange={(e) => setCreatorRemark(e.target.value)}
                    label={"Creator Remark"}
                  />
                  {allowJobCreate && (
                    <div
                      className="field"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div className="ui checkbox">
                        <input
                          type="checkbox"
                          checked={createJob}
                          onChange={(e) => setCreateJob(e.target.checked)}
                        />
                        <label style={{ marginLeft: "5px" }}>Create Job</label>
                      </div>
                    </div>
                  )}
                </div>

                {/*  the location time dates  */}
                <h4 className="ui dividing header">Location ETAs</h4>
                {newDates.locations.map((loc, index) => {
                  const isStart = loc.rlkLocationType === 1;
                  const isEnd = loc.rlkLocationType === 2;
                  const isVia = loc.rlkLocationType === 3;

                  return (
                    <div
                      key={loc.rlkId}
                      className="two fields"
                      style={{ display: "flex", alignContent: "center" }}
                    >
                      <DateTimePickerInput
                        label={`${loc.rlkLocationTypeValue} (${loc.locationName}) – Arrival ETA`}
                        value={loc.rlkArrivalEta}
                        reset={resetLocationFields}
                        setReset={setResetLocationFields}
                        required={true}
                        error={currentErrors[`arrival_${loc.rlkId}`]}
                        resetError={() =>
                          setCurrentErrors((prev) => {
                            const { [`arrival_${loc.rlkId}`]: _, ...rest } =
                              prev;
                            return rest;
                          })
                        }
                        validators={[
                          ...(!allowBackDates
                            ? [
                                {
                                  func: (date) =>
                                    isAfter(dayjs(date), new Date()),
                                  message: "Arrival must be after now",
                                },
                              ]
                            : []),
                          {
                            func: (date) =>
                              !loc.rlkDepartureEta ||
                              isBefore(dayjs(date), loc.rlkDepartureEta),
                            message: "Arrival must be before Departure",
                          },
                          {
                            func: (date) => {
                              const start = newDates.locations.find(
                                (l) => l.rlkLocationType === 1,
                              );
                              if (
                                loc.rlkLocationType === 2 &&
                                start?.rlkArrivalEta
                              ) {
                                return isAfter(
                                  dayjs(date),
                                  start.rlkArrivalEta,
                                );
                              }
                              return true;
                            },
                            message: "End Arrival must be after Start Arrival",
                          },
                          {
                            func: (date) => {
                              const start = newDates.locations.find(
                                (l) => l.rlkLocationType === 1,
                              );
                              if (
                                loc.rlkLocationType === 2 &&
                                start?.rlkDepartureEta
                              ) {
                                return isAfter(
                                  dayjs(date),
                                  start.rlkDepartureEta,
                                );
                              }
                              return true;
                            },
                            message:
                              "End Arrival must be after Start Departure",
                          },
                          {
                            func: (date) => {
                              if (loc.rlkLocationType === 3) {
                                const start = newDates.locations.find(
                                  (l) => l.rlkLocationType === 1,
                                );
                                const end = newDates.locations.find(
                                  (l) => l.rlkLocationType === 2,
                                );
                                if (
                                  start?.rlkDepartureEta &&
                                  end?.rlkArrivalEta
                                ) {
                                  return (
                                    isAfter(
                                      dayjs(date),
                                      start.rlkDepartureEta,
                                    ) &&
                                    isBefore(dayjs(date), end.rlkArrivalEta)
                                  );
                                }
                              }
                              return true;
                            },
                            message:
                              "Via Arrival must be between Start Departure and End Arrival",
                          },
                        ]}
                        onAccept={(value) => {
                          const updated = [...newDates.locations];
                          updated[index].rlkArrivalEta = value;
                          setNewDates((prev) => ({
                            ...prev,
                            locations: updated,
                          }));
                          setCurrentErrors((prev) => {
                            const { [`arrival_${loc.rlkId}`]: _, ...rest } =
                              prev;
                            return rest;
                          });
                        }}
                      />

                      <DateTimePickerInput
                        label={`${loc.rlkLocationTypeValue} (${loc.locationName}) – Departure ETA`}
                        value={loc.rlkDepartureEta}
                        reset={resetLocationFields}
                        required={true}
                        setReset={setResetLocationFields}
                        error={currentErrors[`departure_${loc.rlkId}`]}
                        resetError={() =>
                          setCurrentErrors((prev) => {
                            const { [`departure_${loc.rlkId}`]: _, ...rest } =
                              prev;
                            return rest;
                          })
                        }
                        validators={[
                          ...(!allowBackDates
                            ? [
                                {
                                  func: (date) =>
                                    isAfter(dayjs(date), new Date()),
                                  message: "Departure must be after now",
                                },
                              ]
                            : []),
                          {
                            func: (date) => {
                              if (!loc.rlkArrivalEta) return true;
                              return isAfter(dayjs(date), loc.rlkArrivalEta);
                            },
                            message: "Departure must be after Arrival",
                          },
                          {
                            func: (date) => {
                              const start = newDates.locations.find(
                                (l) => l.rlkLocationType === 1,
                              );
                              if (
                                loc.rlkLocationType === 2 &&
                                start?.rlkDepartureEta
                              ) {
                                return isAfter(
                                  dayjs(date),
                                  start.rlkDepartureEta,
                                );
                              }
                              return true;
                            },
                            message:
                              "End Departure must be after Start Departure",
                          },
                          {
                            func: (date) => {
                              const start = newDates.locations.find(
                                (l) => l.rlkLocationType === 1,
                              );
                              if (
                                loc.rlkLocationType === 2 &&
                                start?.rlkArrivalEta
                              ) {
                                return isAfter(
                                  dayjs(date),
                                  start.rlkArrivalEta,
                                );
                              }
                              return true;
                            },
                            message:
                              "End Departure must be after Start Arrival",
                          },
                          {
                            func: (date) => {
                              const end = newDates.locations.find(
                                (l) => l.rlkLocationType === 2,
                              );
                              if (
                                loc.rlkLocationType === 1 &&
                                end?.rlkDepartureEta
                              ) {
                                return isBefore(
                                  dayjs(date),
                                  end.rlkDepartureEta,
                                );
                              }
                              return true;
                            },
                            message:
                              "Start Departure must be before End Departure",
                          },
                          {
                            func: (date) => {
                              const end = newDates.locations.find(
                                (l) => l.rlkLocationType === 2,
                              );
                              if (
                                loc.rlkLocationType === 1 &&
                                end?.rlkArrivalEta
                              ) {
                                return isBefore(dayjs(date), end.rlkArrivalEta);
                              }
                              return true;
                            },
                            message:
                              "Start Departure must be before End Arrival",
                          },
                          {
                            func: (date) => {
                              if (loc.rlkLocationType === 3) {
                                const start = newDates.locations.find(
                                  (l) => l.rlkLocationType === 1,
                                );
                                const end = newDates.locations.find(
                                  (l) => l.rlkLocationType === 2,
                                );

                                if (
                                  start?.rlkDepartureEta &&
                                  end?.rlkArrivalEta
                                ) {
                                  return (
                                    isAfter(
                                      dayjs(date),
                                      start.rlkDepartureEta,
                                    ) &&
                                    isBefore(dayjs(date), end.rlkArrivalEta)
                                  );
                                }
                              }
                              return true;
                            },
                            message:
                              "Via Departure must be between Start Departure and End Arrival",
                          },
                        ]}
                        onAccept={(value) => {
                          const updated = [...newDates.locations];
                          updated[index].rlkDepartureEta = value;
                          setNewDates((prev) => ({
                            ...prev,
                            locations: updated,
                          }));
                          setCurrentErrors((prev) => {
                            const { [`departure_${loc.rlkId}`]: _, ...rest } =
                              prev;
                            return rest;
                          });
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </form>
          </CardContent>
          <div
            className="extra content"
            style={{ display: "flex", justifyContent: "right" }}
          >
            {/*<Button*/}
            {/*    label={"Reset Locations"}*/}
            {/*    onClick={() => resetLocationETAs()}*/}
            {/*/>*/}
            <Button
              type="button"
              className="ui primary button"
              onClick={handleCreateCopy}
              label="Create Request Copy"
              isLoading={isButtonLoading}
            />
          </div>
        </Card>
      )}
    </>
  );
}

export default RequestCopyModal;
